<template>
    <TopNav :progress="progress" active-page="home" @request-reset="resetProgressToZero" />

    <OmashuExperience @omashu-open="onOmashuOpen" @omashu-close="onOmashuClose" />

    <section v-if="!omashuOpen" class="scroll-track" ref="trackRef">
        <HomeEffect
            :progress="progress"
            @update:progress="progress = $event"
            @finished="heroDone = true"
        />
    </section>
    <!--<div class="scroll-track"></div>-->
    <HomeContent1 v-if="heroDone && !omashuOpen"/>
    <HomeContent2 v-if="heroDone && !omashuOpen"/>
    <HomeContent3 v-if="heroDone && !omashuOpen"/>
    <HomeContent4 v-if="heroDone && !omashuOpen"/>
    <HomeContent5 v-if="heroDone && !omashuOpen"/>
    <HomeContent6 v-if="heroDone && !omashuOpen"/>
    <HomeContent7 v-if="heroDone && !omashuOpen"/>
    <HomeContent8 v-if="heroDone && !omashuOpen"/>
    <FooterGusMachadoYear v-if="!omashuOpen" />
</template>
  
<script setup>
    import { ref, onMounted, onUnmounted } from 'vue'
    import HomeEffect from '@/components/HomeEffect.vue'
    import HomeContent1 from '@/components/HomeContent1.vue'
    import HomeContent2 from '@/components/HomeContent2-quote.vue'
    import HomeContent3 from '@/components/HomeContent3-description.vue'
    import HomeContent4 from '@/components/HomeContent4-numbers.vue'
    import HomeContent5 from '@/components/HomeContent5-projects.vue'
    import HomeContent6 from '@/components/HomeContent6-social.vue'
    import HomeContent7 from '@/components/HomeContent7-clients.vue'
    import HomeContent8 from '@/components/HomeContent8-contact.vue'
    import FooterGusMachadoYear from '@/components/Footer-GusMachadoYear.vue'
    import TopNav from '@/components/TopNav.vue'
    import OmashuExperience from '@/components/Omashu-Experience.vue'

    const progress   = ref(0)
    const heroDone   = ref(false)
    const omashuOpen = ref(false)

    const onOmashuOpen = () => {
        omashuOpen.value = true
        document.body.style.overflow = 'hidden'
    }

    const onOmashuClose = () => {
        omashuOpen.value = false
        setScrollLock(progress.value < 1)
    }

    const trackRef = ref(null)
    const scrollLocked = ref(true)

    const clamp01 = (value) => Math.max(0, Math.min(1, value))

    const setScrollLock = (locked) => {
        scrollLocked.value = locked
        document.body.style.overflow = locked ? 'hidden' : ''
        if (locked) {
            const top = getTrackStart()
            if (Math.abs(window.scrollY - top) > 1) {
                window.scrollTo({ top, behavior: 'auto' })
            }
        }
    }

    const applyProgress = (next) => {
        progress.value = clamp01(next)
        if (progress.value >= 0.99) {
            heroDone.value = true
        }
        setScrollLock(progress.value < 1)
    }

    const getTrackStart = () => {
        if (!trackRef.value) return 0
        return trackRef.value.offsetTop
    }

    const isAtTop = () => window.scrollY <= getTrackStart() + 1

    const forceTrackTop = () => {
        const top = getTrackStart()
        if (Math.abs(window.scrollY - top) > 1) {
            window.scrollTo({ top, behavior: 'auto' })
        }
    }

    const handleWheel = (e) => {
        if (omashuOpen.value) return
        const delta = e.deltaY * 0.001

        if (scrollLocked.value) {
            forceTrackTop()
            e.preventDefault()
            applyProgress(progress.value + delta)
            return
        }

        // Se estiver no topo e o usuário rolar para cima, reativa o controle do progresso
        if (delta <= 0 && isAtTop()) {
            forceTrackTop()
            e.preventDefault()
            applyProgress(progress.value + delta)
        }
    }

    let touchStartY = 0
    const handleTouchStart = (e) => {
        touchStartY = e.touches[0]?.clientY ?? 0
    }

    const isInNavScroll = (target) => {
        const el = target instanceof Element ? target : null
        return !!el?.closest('.nav-scroll')
    }

    const handleTouchMove = (e) => {
        if (omashuOpen.value) return
        const currentY = e.touches[0]?.clientY ?? 0
        const delta = (touchStartY - currentY) * 0.002
        touchStartY = currentY

        if (isInNavScroll(e.target)) {
            return
        }

        if (scrollLocked.value) {
            forceTrackTop()
            e.preventDefault()
            applyProgress(progress.value + delta)
            return
        }

        // Se estiver no topo e o usuário puxar para baixo, reativa o controle do progresso
        if (delta < 0 && isAtTop()) {
            forceTrackTop()
            e.preventDefault()
            applyProgress(progress.value + delta)
        }
    }

    let resetRafId = 0
    const cancelReset = () => {
        if (resetRafId) {
            cancelAnimationFrame(resetRafId)
            resetRafId = 0
        }
    }

    const resetProgressToZero = () => {
        cancelReset()
        if (progress.value <= 0) {
            applyProgress(0)
            return
        }

        const start = performance.now()
        const startValue = progress.value
        const duration = 700

        const tick = (now) => {
            const t = Math.min(1, (now - start) / duration)
            const eased = 1 - Math.pow(1 - t, 3)
            const next = startValue * (1 - eased)
            applyProgress(next)
            if (t < 1) {
                resetRafId = requestAnimationFrame(tick)
            }
        }

        resetRafId = requestAnimationFrame(tick)
    }

    onMounted(() => {
        setScrollLock(progress.value < 1)
        window.addEventListener('wheel', handleWheel, { passive: false })
        window.addEventListener('touchstart', handleTouchStart, { passive: true })
        window.addEventListener('touchmove', handleTouchMove, { passive: false })
    })

    onUnmounted(() => {
        window.removeEventListener('wheel', handleWheel)
        window.removeEventListener('touchstart', handleTouchStart)
        window.removeEventListener('touchmove', handleTouchMove)
        document.body.style.overflow = ''
        cancelReset()
    })

    // Calculadora de proporcao de tela

    /* const widthScreen = ref(window.innerWidth);
    const heightScreen = ref(window.innerHeight);

    const handleResize = () => {
        widthScreen.value = window.innerWidth;
        heightScreen.value = window.innerHeight;
    }

    onMounted(() => window.addEventListener('resize', handleResize));
    onUnmounted(() => window.removeEventListener('resize', handleResize));

    const isThreeFourRatio = computed(() => {
        const currentRatio = widthScreen.value / heightScreen.value;
        const targetRatio = 3 / 4; // 0.75
        
        // Use a small epsilon for float comparison (optional)
        const tolerance = 0.01; 
        const match = Math.abs(currentRatio - targetRatio) < tolerance;
        
        return match ? 1 : 0;
    });*/

</script>
  
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
}

/*.scroll-track {
  height: 100vh; controla quanto scroll alimenta o efeito 
}*/

.scroll-track {
  position: relative;
}
</style>
